/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LogOutt, ExtenderTiempo } from "store/login/loginSlice";
import { persistor } from "store/store";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

const AutoLogout = ({ warningBefore = 60 * 1000 }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const laction = useLocation();
  const {token, usuario} = useSelector((state) => state.login);
  const logoutTimer = useRef(null);
  const warningTimer = useRef(null);
  const countdownInterval = useRef(null);
  const actividadTimer = useRef(null);
  const [showWarning, setShowWarning] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(0);
  const [usuarioActivo, setUsuarioActivo] = useState(true);

  // 👇 Detectar actividad del usuario
  const registrarActividad = () => {
    setUsuarioActivo(true);
    clearTimeout(actividadTimer.current);
    actividadTimer.current = setTimeout(() => {
      setUsuarioActivo(false);
    }, 30000); // 30s sin interacción = inactivo
  };

  useEffect(() => {
    const eventos = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];
    eventos.forEach((evento) => window.addEventListener(evento, registrarActividad));
    registrarActividad(); // al montar, lo marcamos como activo

    return () => {
      eventos.forEach((evento) => window.removeEventListener(evento, registrarActividad));
      clearTimeout(actividadTimer.current);
    };
  }, []);

  const handleLogout = () => {
    dispatch(LogOutt(token));
    persistor.purge();
    setShowWarning(false);
    stopCountdown();
    if(location.pathname == "/registrar"){
       navigate("/registrar");
    }else{
    navigate("/", {
          state:{
            message:"Sesión finalizada por inactividad"
          }
        });
    }
   
  };

  const startCountdown = (duration) => {
    setSecondsLeft(Math.floor(duration / 1000));
    countdownInterval.current = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(countdownInterval.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const stopCountdown = () => {
    clearInterval(countdownInterval.current);
  };

  useEffect(() => {
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      const expMs = decoded.exp * 1000;
      const now = Date.now();
       const logoutEarly = 60 * 1000; // cerrar o renovar 1 minuto antes
      const timeUntilExpire = expMs - now - logoutEarly;
      if (timeUntilExpire <= 0) {
        handleLogout();
        return;
      }

      // Mostrar advertencia antes de expirar (ej. 60s antes)
      warningTimer.current = setTimeout(() => {
        if(usuarioActivo){
          dispatch(ExtenderTiempo(usuario, token));
        }else{
          setShowWarning(true);
          startCountdown(warningBefore);
        }
      }, timeUntilExpire - warningBefore);

      // Expirar sesión al llegar a exp
      logoutTimer.current = setTimeout(() => {
        handleLogout();
      }, timeUntilExpire);

      return () => {
        clearTimeout(warningTimer.current);
        clearTimeout(logoutTimer.current);
        stopCountdown();
      };
    } catch (err) {
      console.error("Token inválido:", err);
      handleLogout(); // Por seguridad
    }
  }, [token]);

  const handleContinueSession = () => {
    setShowWarning(false);
    stopCountdown();
    // 👇 Aquí puedes hacer refresh del token si tu backend lo permite
    dispatch(ExtenderTiempo(usuario, token));
  };

  return (
    <Dialog open={showWarning} >
      <DialogTitle style={{ backgroundColor: "#1a2035", color:"white" }}>Sesión inactiva</DialogTitle>
      <DialogContent style={{ backgroundColor: "#1a2035", color:"white" }}>
        <Typography>
          Has estado inactivo. Tu sesión se cerrará en{" "}
          <strong style={{color:"green"}}>{formatTime(secondsLeft)}</strong> minutos si no respondes.
        </Typography>
      </DialogContent>
      <DialogActions style={{ backgroundColor: "#1a2035" }}>
        <Button onClick={handleContinueSession} color="warning" variant="contained">
          Continuar sesión
        </Button>
      </DialogActions>
    </Dialog>
  );
};

function formatTime(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
}

export default AutoLogout;
